module.exports = __webpack_public_path__ + "static/media/wheatDough.8b4bf901.png";